import styled from 'styled-components';

const InsulatingMattressesWrapper = styled.div``;

export { InsulatingMattressesWrapper };
